import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Tooltip from '../components/Tooltip'
import Checkbox from '../components/Checkbox'
import GlyphDots from '../icons/GlyphDots'

const Token = ({
  tokenId, startTime, endTime, reservedTime, onSelect, onMove, focused, selected, cantSelect
}) => {
  const dotsWrapper = useRef()

  let className = 'File ml4 mr4 b--light-gray relative flex items-center bt'
  const styles = { height: 74, overflow: 'hidden' }

  if (focused) {
    styles.border = '1px dashed #9ad4db'
  } else {
    styles.border = '1px solid transparent'
    styles.borderTop = '1px solid #eee'
  }

  const select = (select) => onSelect(tokenId, select)

  const checkBoxCls = classnames({
    'o-70 glow': !cantSelect,
    'o-1': selected || focused
  }, ['pl2 w2'])

  const jabraNumberMask = 255;
  const jabraNumber = (tokenId & jabraNumberMask) + 1; // In Solidity the Jabra number begins at 0, but in real world begins at 1.
  const startTimeString = new Date(startTime * 1000).toLocaleString("ja");
  const endTimeString = new Date(endTime * 1000).toLocaleString("ja");
  const reservedTimeString = new Date(reservedTime * 1000).toLocaleString("ja");

  return (
    <div className={className} style={styles}>
      <div className={checkBoxCls}>
        <Checkbox disabled={cantSelect} checked={selected} onChange={select} aria-label={ ('checkboxLabel', { tokenId }) } />
      </div>

      <div className='flex' style={{ width: '10.5rem' }}>
        <div className='pr4 pl2 pv1 flex-none f6 db-l gray times-new-roman'>
          <Tooltip text='tokenId'>
            <div className='f6 pt1 pb1 pr1 truncate charcoal'>{tokenId}</div>
          </Tooltip>
          <Tooltip text='jabraNumber'>
            <div className='f6 mn1 pt1 pb1 pr1 gray truncate times-new-roman'>{jabraNumber}</div>
          </Tooltip>
        </div>
      </div>
      <div className='flex' style={{ width: '10.5rem' }}>
        <div className='pr4 pl2 pv1 flex-none f6 db-l gray times-new-roman'>
          <Tooltip text='tokenId'>
            <div className='f6 pt1 pb1 pr1 gray truncate'>{startTimeString}</div>
          </Tooltip>
          <Tooltip text='jabraNumber'>
            <div className='f6 mn1 pt1 pb1 pr1 gray truncate times-new-roman'>{endTimeString}</div>
          </Tooltip>
        </div>
      </div>
      <div className='flex' style={{ margin: '0 0 0 auto'}}>
        <div className='pl2 pr4 pv1 flex-none f6 db-l dn gray times-new-roman' style={{ margin: 'auto 0' }}>{reservedTimeString}</div>
        <button ref={dotsWrapper} className='ph2 db button-inside-focus' style={{ width: '3.25rem' }} aria-label={ ('checkboxLabel', { tokenId }) } >
          <GlyphDots className='fill-gray-muted pointer hover-fill-gray transition-all'/>
        </button>
      </div>
    </div>
  )
}

File.propTypes = {
  tokenId: PropTypes.number.isRequired,
  reserveTime: PropTypes.number.isRequired,
  reservedTime: PropTypes.number.isRequired,
  selected: PropTypes.bool,
  focused: PropTypes.bool,
  onSelect: PropTypes.func,
  onMove: PropTypes.func.isRequired,
}

export default Token;
